import {
    GET_SELLER_AUTH_CONTEXT,
    GET_SELLER_DASHBOARD_METRICS,
    GET_SELLER_PROFILE,
    UPDATE_SELLER_ACCOUNT,
    WITHDRAW_SELLER_WALLET,
} from '@/app/_shared/graphql/queries/sellers.graphql';
import { apolloClient } from '@/app/_shared/lib/apollo-client';
import type { UpdateSellerAccountInput } from '@/graphql/graphql';

export const updateSellerAccount = async (input: UpdateSellerAccountInput) => {
    const normalizedInput = {
        ...input,
        contactEmail: input.contactEmail?.toLocaleLowerCase(),
        billingEmail: input.billingEmail?.toLocaleLowerCase(),
    };
    const result = await apolloClient.mutate({
        mutation: UPDATE_SELLER_ACCOUNT,
        variables: { input: normalizedInput },
    });
    return { data: result };
};

export const getSellerProfile = async (id: string) => {
    const response = await apolloClient.query({
        query: GET_SELLER_PROFILE,
        variables: { id },
    });
    return response.data.seller.account;
};

export const getSellerAuthContext = async () => {
    const response = await apolloClient.query({
        query: GET_SELLER_AUTH_CONTEXT,
    });
    return response.data.seller.account;
};

export const getSellerDashboardMetrics = async (id: string) => {
    const response = await apolloClient.query({
        query: GET_SELLER_DASHBOARD_METRICS,
        variables: { id },
    });
    return response.data.seller.account;
};

export const withdrawSellerWallet = async (sellerId: string) => {
    const result = await apolloClient.mutate({
        mutation: WITHDRAW_SELLER_WALLET,
        variables: { sellerId },
    });
    if (!result.data) {
        throw new Error('withdrawSellerWallet mutation returned no data');
    }
    return result.data;
};
